import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { IReportConfigEntry } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { INotesDatasource } from '../datasources/notes_datasource';

angular
  .module('capability-ng-reports')
  .factory(
    'loadNotesCommand',
    ($http: ng.IHttpService, defineCommandORM: IDefineCommand, ngNotesDatasource: INotesDatasource): ICommand => {
      return defineCommandORM(
        'loadNotesCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          reportConfig: IReportConfigEntry,
          studentNK: string,
          campusUrl: string,
          token: string
        ): void => {
          const config = {
            url: campusUrl + '/api/v3/students/' + studentNK + '/notes',
            method: 'GET',
            headers: {
              Authorization: token,
              isCampusAPI: true
            },
            params: {
              date: reportConfig.last_enabled_dt
            }
          };
          $http(config)
            .then(({ data }: any) => {
              ngNotesDatasource.clear().write(data.data);
              deferred.resolve(data);
            })
            .catch((e: any) => {
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/commands/load_notes_command.ts